import * as React from 'react';
import { render } from 'react-dom';

function loadComponents(): Promise<{[key: string]: any}> {
  return new Promise((resolve, reject) => {
    require.ensure(['./components/PrintOfferButton'], () => {
      resolve({
        PrintOfferButton: require('./components/PrintOfferButton').default
      })
    });
  });
}

export default function initPrintOfferButton() {
  // TODO fix type Object
  (window as any).renderPrintOfferButton = function(element: Element, options: Object) {

    loadComponents()
    .then(({ PrintOfferButton } = {}) => render(<PrintOfferButton {...options} />, element));
  }
}



// WEBPACK FOOTER //
// ./src/bundles/print/index.tsx